import InterviewsPages from './subPages/interviews';
import InterviewStorePoolsPages from './subPages/interviewStorePools';

const routes = [
  {
    path: '/interviews/*',
    canUse: [],
    Component: InterviewsPages,
    hideLayout: ['print'],
  },
  {
    path: '/interview_store_pools/*',
    canUse: [],
    Component: InterviewStorePoolsPages,
  },
];

export default routes;
